import styled from "styled-components";
import { ScrollWrapper } from "src/Components/ui/simpleBar";

export const Wrapper = styled(ScrollWrapper)`
  padding: 0 10%;
  overflow: auto;
  height: ${({ windowHeight }) => (windowHeight ? `${windowHeight}px` : "100vh")};
`;
